import { Loader2 } from "lucide-react";

interface LoadingSpinnerProps {
  size?: "sm" | "default" | "lg";
  className?: string;
}

export const LoadingSpinner = ({ 
  size = "default",
  className = ""
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    default: "w-8 h-8",
    lg: "w-12 h-12"
  };

  return (
    <div className="flex justify-center items-center">
      <Loader2 
        className={`animate-spin ${sizeClasses[size]} ${className}`}
      />
    </div>
  );
};